const firebaseConfig = {
  apiKey: "AIzaSyD2ugtBSR28FzeBLyk28Y8k4lHu40yOn6w",
  authDomain: "nitp-complaint-portal.firebaseapp.com",
  projectId: "nitp-complaint-portal",
  storageBucket: "nitp-complaint-portal.appspot.com",
  messagingSenderId: "647236236461",
  appId: "1:647236236461:web:1ad6e2644aa54d98e4c224"
};

  
  export default firebaseConfig;